module.exports = "\n<div id=\"top\" style=\"margin:0 auto; min-width: 600px; width:90%;\">\n\n\n  <mat-card>\n      \n      <h4 style=\"text-align:center; font-weight:bold; margin:0 auto;\">Settings</h4>\n      <br>\n      <mat-card>\n        <a role=\"button\" (click)=\"update_password()\">Update Password</a>\n      </mat-card> \n      <br>\n      <mat-card>\n        <a role=\"button\" (click)=\"update_username()\">Update Username</a>\n      </mat-card> \n    \n    "


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/settings.component.html
// module id = ./src/app/settings/settings.component.html
// module chunks = main